import styled from '@emotion/styled';
import PropTypes from 'prop-types';
import Icon from './Icon';

const StyledIcon = styled(Icon)`
  fill: none;
`;

const Fonts = (props) => {
  const { color, ...rest } = props;
  return (
    // eslint-disable-next-line react/jsx-props-no-spreading
    <StyledIcon {...rest} viewBox="0 0 24 24">
      <path
        d="M1 18.5L7.11111 5.5L13.2222 18.5"
        stroke={color}
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.8335 15.0791H11.3891"
        stroke={color}
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M22.9998 11.658V11.658C22.2222 10.7873 21.1102 10.2896 19.9428 10.2896H19.4297C17.3513 10.2896 15.6665 11.9744 15.6665 14.0527V14.0527C15.6665 16.131 17.3513 17.8159 19.4297 17.8159H19.9428C21.1102 17.8159 22.2222 17.3181 22.9998 16.4474V16.4474"
        stroke={color}
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M23 10.9736V17.8157"
        stroke={color}
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </StyledIcon>
  );
};

Fonts.propTypes = {
  color: PropTypes.string.isRequired
};

export default Fonts;
